import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";

const NAV_LINKS = [
  { path:"/dashboard",        label:"Ana Sayfa",     icon:"🏠" },
  { path:"/sifre-olcer",      label:"Şifre Ölçer",   icon:"🛡️" },
  { path:"/sifre-avcisi",     label:"Şifre Avcısı",  icon:"🤖" },
  { path:"/guvenlik-karnesi", label:"Karne",          icon:"📊" },
  { path:"/siber-dedektif",   label:"Dedektif",       icon:"🔍" },
  { path:"/phishing",         label:"Phishing",       icon:"🎣" },
  { path:"/domino",           label:"Domino",         icon:"🎲" },
  { path:"/kalkan-lab",       label:"2FA Lab",        icon:"🔐" },
  { path:"/veri-ihlal",       label:"İhlal",          icon:"🌍" },
];

export default function Navbar() {
  const { logout } = useAuth();
  const navigate   = useNavigate();
  const location   = useLocation();
  const [menuAcik, setMenuAcik] = useState(false);

  const handleLogout = async () => { await logout(); navigate("/login"); };

  return (
    <>
      <style>{`
        .navbar{position:sticky;top:0;z-index:50;background:rgba(10,10,15,0.95);backdrop-filter:blur(16px);border-bottom:1px solid #1a1a2e;font-family:'Sora',sans-serif;}
        .nav-inner{max-width:1280px;margin:0 auto;display:flex;align-items:center;gap:0.5rem;padding:0 1rem;height:54px;}
        .nav-logo{font-family:'Space Mono',monospace;font-size:0.95rem;font-weight:700;color:#6c63ff;cursor:pointer;border:none;background:transparent;white-space:nowrap;flex-shrink:0;padding:0 0.5rem 0 0;}
        .nav-links{display:flex;align-items:center;gap:0.05rem;flex:1;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;}
        .nav-links::-webkit-scrollbar{display:none;}
        .nav-link{display:flex;align-items:center;gap:0.25rem;padding:0.35rem 0.55rem;border-radius:7px;font-size:0.73rem;font-weight:500;color:#6b6b80;cursor:pointer;border:none;background:transparent;transition:color .2s,background .2s;font-family:'Sora',sans-serif;white-space:nowrap;flex-shrink:0;}
        .nav-link:hover{background:rgba(108,99,255,0.1);color:#e8e8f0;}
        .nav-link.active{background:rgba(108,99,255,0.18);color:#6c63ff;font-weight:600;}
        .nav-link span:first-child{font-size:0.85rem;}
        .nav-right{display:flex;align-items:center;gap:0.4rem;flex-shrink:0;}
        .nav-logout{background:transparent;border:1px solid #1e1e2e;color:#6b6b80;padding:0.35rem 0.75rem;border-radius:7px;font-family:'Sora',sans-serif;font-size:0.75rem;cursor:pointer;transition:border-color .2s,color .2s;white-space:nowrap;}
        .nav-logout:hover{border-color:rgba(255,80,80,0.4);color:#ff6b6b;}
        .hamburger{display:none;flex-direction:column;gap:4px;background:transparent;border:none;cursor:pointer;padding:6px;flex-shrink:0;}
        .hamburger span{display:block;width:18px;height:2px;background:#6b6b80;border-radius:2px;transition:background .2s;}
        .hamburger:hover span{background:#e8e8f0;}
        .mobile-menu{display:none;flex-direction:column;background:rgba(10,10,15,0.98);border-bottom:1px solid #1a1a2e;padding:0.5rem 1rem 1rem;}
        .mobile-grid{display:grid;grid-template-columns:1fr 1fr;gap:0.35rem;margin-bottom:0.5rem;}
        .mobile-link{display:flex;align-items:center;gap:0.5rem;padding:0.6rem 0.75rem;border-radius:10px;font-size:0.85rem;font-weight:500;color:#6b6b80;cursor:pointer;border:none;background:rgba(255,255,255,0.03);font-family:'Sora',sans-serif;transition:all .2s;text-align:left;}
        .mobile-link:hover,.mobile-link.active{background:rgba(108,99,255,0.12);color:#6c63ff;}
        .mobile-sep{height:1px;background:#1a1a2e;margin:0.5rem 0;}
        .mobile-logout{width:100%;display:flex;align-items:center;gap:0.5rem;padding:0.6rem 0.75rem;border-radius:10px;font-size:0.85rem;font-weight:500;color:#f87171;cursor:pointer;border:none;background:rgba(239,68,68,0.06);font-family:'Sora',sans-serif;transition:all .2s;}
        .mobile-logout:hover{background:rgba(239,68,68,0.12);}
        @media(max-width:900px){
          .nav-links{display:none !important;}
          .nav-logout{display:none !important;}
          .hamburger{display:flex !important;}
          .mobile-menu{display:flex !important;}
        }
      `}</style>

      <nav className="navbar">
        <div className="nav-inner">
          <button className="nav-logo" onClick={() => navigate("/dashboard")}>🛡️ MyApp</button>

          <div className="nav-links">
            {NAV_LINKS.map(({ path, label, icon }) => (
              <button key={path} className={`nav-link ${location.pathname===path?"active":""}`} onClick={() => navigate(path)}>
                <span>{icon}</span><span>{label}</span>
              </button>
            ))}
          </div>

          <div className="nav-right">
            <button className="nav-logout" onClick={handleLogout}>Çıkış</button>
            <button className="hamburger" onClick={() => setMenuAcik(o => !o)}>
              <span /><span /><span />
            </button>
          </div>
        </div>

        {menuAcik && (
          <div className="mobile-menu">
            <div className="mobile-grid">
              {NAV_LINKS.map(({ path, label, icon }) => (
                <button key={path} className={`mobile-link ${location.pathname===path?"active":""}`}
                  onClick={() => { navigate(path); setMenuAcik(false); }}>
                  <span>{icon}</span><span>{label}</span>
                </button>
              ))}
            </div>
            <div className="mobile-sep" />
            <button className="mobile-logout" onClick={handleLogout}>🚪 Çıkış Yap</button>
          </div>
        )}
      </nav>
    </>
  );
}
